import useWindowSize from '@rehooks/window-size';

export default function(defaultHeight = 1000) {
  let windowSize = {
    innerHeight: defaultHeight,
  };
  windowSize = typeof window !== 'undefined' && useWindowSize();
  return windowSize.innerHeight;
}
